import template from "./template";
import * as D from "./data";
import * as S from "./style";
import * as L from "./logics";
import * as C from "./components";

export const T = template;

export const banner = {
  D,
  S,
  T,
  C,
  L,
};

export default T;
